module.exports = __webpack_public_path__ + "media/images/check2-482f1c78.png";